export default __webpack_public_path__ + "static/careers-team-link-block1-icon.url-9eac3012321034a540a644a3bc434305.svg";